import React from "react";
import "../../styles/auth.css";

function InputField({
  type,
  placeholder,
  icon,
  iconClass,
  iconClick,
  inputClass,
  className,
  label,
  name,
  value,
  optional,
  onChange,
  disabled,
  textarea,
}) {
  return (
    <>
      {label && (
        <p className="sectionText textIsBold--semi mb-1 lAlign">{label}</p>
      )}
      <div className={`input__custom alignOnly ${className}`}>
        {textarea ? (
          <textarea
            type={type}
            placeholder={placeholder}
            name={name}
            value={value}
            className={inputClass}
            required={!optional}
            onChange={onChange}
            disabled={disabled}
            rows={5}
          />
        ) : (
          <input
            type={type}
            placeholder={placeholder}
            name={name}
            value={value}
            className={inputClass}
            required={!optional}
            onChange={onChange}
            disabled={disabled}
          />
        )}

        {icon && (
          <i className={`isClickable ${iconClass}`} onClick={iconClick} />
        )}
      </div>
    </>
  );
}

export default InputField;
